<template>
    <div class="AccountCancellate">
        <!--注销账户-->
        <ul>
            <li class='phone'>
                <input type="text" v-model="perInfo.phone" placeholder="手机号码" readonly>
            </li>
            <li class='code' :class="getCode">
                <input type="text" v-model="phone_code" placeholder='请输入验证码'>
                <span>{{ mesCode}}</span>
                <button type="button" @click="getNewCode()">{{ codeMsg }}</button>
            </li>
        </ul>
        <div class="btn" @click="logout()">账户注销</div>
        <!--注销提示-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="550px"
                center>
            <div class="delReminder">
                账户注销后会清空您的所有数据，是否确认注销！
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="affirm()">确 定</el-button>
                <el-button class="button" @click="cancel()">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script type="text/ecmascript-6">
	import {deleteAccounts, getPhoneCode} from '../../api/index'

	export default {
		data() {
			return {
				// 获取验证码按钮
				codeMsg: '获取验证码',
				perInfo: {
					phone: '',
				},
				phone_code: '',
				ISFS: true,
				YiFa: false,
				dialogVisible: false,
				mesCode: '',
				token: ""
			}
		},
		mounted() {
			this.perInfo.phone = JSON.parse(localStorage.getItem('userInfo')).phone
			// this.init()
			if (localStorage.getItem('isLogin') === '1') {
				this.token = localStorage.getItem('token')
			}
		},
		computed: {
			getCode() {
				if (this.phone_code !== '') {
					this.mesCode = ''
				}
			},
		},
		methods: {
			// init() {
			// 	getWeixinAcc({}).then(res => {
			// 		if (res.code === 0) {
			// 			this.perInfo.phone = res.data.phone;
			// 		}
			// 		// console.log(res)
			// 	}).catch(err => {
			// 		this.$message({
			// 			message: err.msg,
			// 			type: 'warning'
			// 		})
			// 	})
			// },
			//注销
			logout() {
				if (this.phone_code === '') {
					this.mesCode = '请输入验证码'
				} else {
					this.dialogVisible = true
				}
			},
			//取消注销
			cancel() {
				this.$message({
					message: '取消注销',
					type: 'warning'
				});
				this.dialogVisible = false
			},
			//确认注销
			affirm() {
				deleteAccounts({
					phone_code: this.phone_code,
					token: this.token
				}).then(res => {
					console.log(res)
					if (res.code === 0) {
						this.$message({
							message: res.msg,
							type: 'success'
						})
						localStorage.setItem('isLogin', '0');
						localStorage.removeItem('token');
						localStorage.removeItem('userInfo');
						this.$router.push('/home')
						this.dialogVisible = false
					} else {
						this.$message({
							message: res.msg,
							type: 'success'
						})
					}
				}).catch(err => {
					this.$message.error(err.msg)
					this.dialogVisible = false
				})
			},
			//获取验证码
			getNewCode() {
				if (this.ISFS === true) {
					this.codeTiming();
				} else {
					this.$message({
						message: '请稍后再试',
						type: 'warning'
					});
				}
			},
			// 获取验证码
			codeTiming() {
				let _this = this;
				getPhoneCode({
                  token: this.token
                }).then(result => {
					// console.log(result)
					this.$message({
						message: result.msg,
						type: 'success'
					})
					_this.ISFS = false; //更改为不可以发送
					_this.YiFa = true;//更改为不可选的按钮
					if (result.code === 0) {
						let times = 60;
						let dinshiqi = setInterval(function () {
							times--;
							_this.codeMsg = times + "s" + "后重新获取";
							if (times < 1) {
								clearInterval(dinshiqi);
								_this.ISFS = true;
								_this.codeMsg = "获取验证码"
								_this.YiFa = false
							}
						}, 1000);
					}
					if (result.code === -1) {
						this.$message({
							message: result.msg,
							type: 'warning'
						})
					}
				}).catch(err => {
					this.$message({
						message: err.msg,
						type: 'warning'
					})
				})
			}
		},
	}
</script>

<style lang="less" rel="stylesheet/less" scoped>
    .AccountCancellate {
        width: 440px;
        padding: 30px 40px 40px;
        /*margin-top: 40px;*/
        border: 1px solid #e6e6e6;
        ul {
            li {
                position: relative;
                margin-top: 15px;
                border-bottom: 1px solid #E6E6E6;
                input {
                    width: 100%;
                    color: #4d4d4d;
                    line-height: 42px;
                    border: none;
                    outline: none;
                }
                span {
                    font-size: 14px;
                    position: absolute;
                    top: 100%;
                    left: 0;
                    color: #FF5E5E;
                }
            }
            li:first-child {
                margin-top: 0;
            }
            .code {
                position: relative;
                button {
                    position: absolute;
                    right: 0;
                    bottom: 1px;
                    width: 120px;
                    height: 40px;
                    font-size: 14px;
                    color: #fff;
                    background: #50B3FF;
                    border: none;
                    border-radius: 2px;
                    cursor: pointer;
                }
            }
        }
        .btn {
            width: 100%;
            font-size: 14px;
            color: #fff;
            text-align: center;
            background: #FF5E5E;
            border-radius: 2px;
            line-height: 44px;
            margin: 40px 0 0;
            cursor: pointer;
        }
        .delReminder {
            font-size: 16px;
            color: #FF5E5E;
        }
    }
</style>